import { render } from "./pk10.vue?vue&type=template&id=70531cfd&scoped=true"
import script from "./pk10.vue?vue&type=script&lang=js"
export * from "./pk10.vue?vue&type=script&lang=js"

import "./pk10.vue?vue&type=style&index=0&id=70531cfd&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70531cfd"]])

export default __exports__